export class PMUSSettings {constructor(c={}) { 
  Object.assign(this, {
    toggleType: 'neutral',
    toggleColor: '#47d747',
    toggleActiveColor: '#ffffff',
    toggleText: 'On',
    toggleOffColor: '#cccccc',
    toggleOffActiveColor: '#ffffff',
    toggleOffText: 'Off',

    minHeight: { type: 'auto', value: 1 },
    maxHeight: { type: 'px', value: 250 },
    selectedLanguage: '',

    viewAllText: 'View All',
    viewLessText: 'View Less',

    descriptionSpacing: { paddingLeft: 0, paddingRight: 0, paddingTop: 16, paddingBottom: 16 },
    descriptionFont: { fontSize: 13, fontWeight: '500', color: '#000000', fontFamily: 'arial, helvetica, sans-serif' },

    nameSpacing: { paddingLeft: 0, paddingRight: 0, paddingTop: 16, paddingBottom: 16 },
    nameFont: { fontSize: 14, fontWeight: '500', color: '#000000', fontFamily: 'arial, helvetica, sans-serif' },

    stackCategoriesSpacing: { paddingLeft: 0, paddingRight: 15, paddingTop: 0, paddingBottom: 10 },
    stackCategoriesFont: { fontSize: 12, fontWeight: '600', color: '#000000', fontFamily: 'arial, helvetica, sans-serif' },

    borderColor: 'gray',

    gpcVisible: true,
    languages: { EN: { gpcText: 'GPC is Enabled' } },
    gpcSpacing: { paddingLeft: 20, paddingRight: 16, paddingTop: 16, paddingBottom: 16 },
    gpcFont: { fontSize: 13, fontWeight: '600', color: '#118d30', fontFamily: 'arial, helvetica, sans-serif' },

    pplSpacing: { paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0 },
    pplFont: { fontSize: 13, fontWeight: '500', color: 'black', fontFamily: 'arial, helvetica, sans-serif' },
    linkStyle: { fontWeight: '400', color: '#0000ff', textDecoration: 'none' },
    linkHoverStyle: { fontWeight: '400', color: '#0000ff', textDecoration: 'underline' },

    identificationListSpacing: { paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0 },
    identificationListFont: { fontSize: 13, fontWeight: '500', color: 'black', fontFamily: 'arial, helvetica, sans-serif' },

    background: 'none',
    padding: { paddingLeft: 10, paddingRight: 10, paddingTop: 10, paddingBottom: 10 },
    margin: { marginLeft: 10, marginRight: 10, marginTop: 10, marginBottom: 10 },
    border: { borderWidth: 0, borderColor: '#000000', borderTopLeftRadius: 0, borderTopRightRadius: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderStyle: 'solid' },
  });
  Object.assign(this, c);
}}

export const PMUSTypes = {
  height: {
    minHeight: { title: 'Min Scroll Height', type: 'Size' },
    maxHeight: { title: 'Max Scroll Height', type: 'Size' }
  },
  descriptions: {
    descriptionSpacing: { title: 'Padding', type: 'Padding' },
    descriptionFont: { title: 'Font', type: 'Font' }
  },
  names: {
    nameSpacing: { title: 'Padding', type: 'Padding' },
    nameFont: { title: 'Font', type: 'Font' }
  },
  'Stack Categories': {
    stackCategoriesSpacing: { title: 'Padding', type: 'Padding' },
    stackCategoriesFont: { title: 'Font', type: 'Font' }
  },
  'Separator color': {
    borderColor: { title: 'Color', type: 'ColorPicker' },
  },
  'GPC Settings': {
    gpcVisible: { title: 'Show GPC?', type: 'Switch' },
    gpcText: { title: 'GPC Text', type: 'InputLanguage' },
    gpcSpacing: { title: 'Padding', type: 'Padding' },
    gpcFont: { title: 'Font', type: 'Font' }
  },
  'Toggle settings': {
    toggleType: { title: 'Type', type: 'ToggleType' },
    toggleColor: { title: 'ON Color', type: 'ColorPicker' },
    toggleActiveColor: { title: 'ON Active Text Color', type: 'ColorPicker' },
    toggleText: { title: 'ON Text', type: 'InputLanguage' },
    toggleOffColor: { title: 'OFF Color', type: 'ColorPicker' },
    toggleOffActiveColor: { title: 'OFF Active Text Color', type: 'ColorPicker' },
    toggleOffText: { title: 'OFF Text', type: 'InputLanguage' },
  },
  'Separator color': {
    borderColor: { title: 'Color', type: 'ColorPicker' },
  },
  'Privacy Policy link': {
    pplSpacing: { title: 'Padding', type: 'Padding' },
    pplFont: { title: 'Font', type: 'Font' },
    linkStyle: { title: 'Link Style', type: 'Links' },
    linkHoverStyle: { title: 'Link Hover Style', type: 'Links' }
  },
  'Identification List': {
    identificationListSpacing: { title: 'Padding', type: 'Padding' },
    identificationListFont: { title: 'Font', type: 'Font' }
  },
  Spacing: {
    padding: { title: 'Padding', type: 'Padding' },
    margin: { title: 'Margin', type: 'Margin' },
  },
  Styles: {
    background: { title: 'Background Color', type: 'ColorPicker' },
    border: { title: 'Border', type: 'Border' },
  }
};